import { render, staticRenderFns } from "./FilterK3l.vue?vue&type=template&id=1472138e&"
import script from "./FilterK3l.vue?vue&type=script&lang=js&"
export * from "./FilterK3l.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports